"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ApptDetails;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _utils = require("../../../lib/utils");
var _Message = _interopRequireDefault(require("../Message"));
var _ApptTime = require("./ApptTime");
var _LocationDetails = require("./LocationDetails");
var _LocationMap = require("./LocationMap");
var _styles = require("./styles");
var _PreVisitCheckIn = require("./PreVisitCheckIn");
function ApptDetails(_ref) {
  let {
    provider,
    appointment,
    location,
    track,
    config,
    awsMapConfig
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_styles.ApptDetailsContainer, null, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_ApptTime.ApptTime, {
    appointment: appointment
  }), /*#__PURE__*/_react.default.createElement(_LocationDetails.LocationDetails, {
    location: location,
    provider: provider,
    appointment: appointment
  }), /*#__PURE__*/_react.default.createElement(_Message.default, {
    provider: provider
  }), appointment.previsit_url && /*#__PURE__*/_react.default.createElement(_PreVisitCheckIn.PreVisitCheckIn, {
    checkInUrl: appointment.previsit_url,
    track: track,
    providerId: provider.id
  })), !(0, _utils.hasAnyVideoPhoneAppt)(appointment.visit_method) && /*#__PURE__*/_react.default.createElement(_LocationMap.LocationMap, {
    providerId: provider.id,
    location: location,
    track: track,
    config: config,
    awsMapConfig: awsMapConfig
  }));
}
ApptDetails.propTypes = {
  provider: _propTypes.default.object.isRequired,
  appointment: _propTypes.default.object.isRequired,
  location: _propTypes.default.object.isRequired,
  track: _propTypes.default.func.isRequired,
  config: _propTypes.default.object.isRequired,
  awsMapConfig: _propTypes.default.object
};
ApptDetails.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ApptDetails",
  "props": {
    "provider": {
      "description": "",
      "type": {
        "name": "object"
      },
      "required": true
    },
    "appointment": {
      "description": "",
      "type": {
        "name": "object"
      },
      "required": true
    },
    "location": {
      "description": "",
      "type": {
        "name": "object"
      },
      "required": true
    },
    "track": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": true
    },
    "config": {
      "description": "",
      "type": {
        "name": "object"
      },
      "required": true
    },
    "awsMapConfig": {
      "description": "",
      "type": {
        "name": "object"
      },
      "required": false
    }
  }
};